
namespace Gamification.Gamification {

    enum AmbitoEnum {
        Indefinito = 0,
        VisualizzaAssetEsperienze = 1,
        VisualizzaRisorse = 2
    }

    @Serenity.Decorators.registerEditor('Gamification.Gamification.AssetEsperienzeRisorse2Editor')
    export class AssetEsperienzeRisorse2Editor extends Serenity.EntityGrid<AssetEsperienzeRisorseRow, any> {
        protected getColumnsKey() { return AssetEsperienzeRisorseColumns.columnsKey; }
        protected getDialogType() { return AssetEsperienzeRisorseDialog; }
        protected getIdProperty() { return AssetEsperienzeRisorseRow.idProperty; }
        protected getInsertPermission() { return AssetEsperienzeRisorseRow.insertPermission; }
        protected getLocalTextPrefix() { return AssetEsperienzeRisorseRow.localTextPrefix; }
        protected getService() { return AssetEsperienzeRisorseService.baseUrl; }

        static AmbitoEnum = AmbitoEnum;

        constructor(container: JQuery) {
            super(container);
        }

        protected getViewOptions() {
            var opt = super.getViewOptions();
            opt.rowsPerPage = 100;
            return opt;
        }

        protected getInitialTitle() {
            return null;
        }

        protected usePager() {
            return true;
        }

        protected createQuickSearchInput() { }

        protected getGridCanLoad() {
            return this.idRisorsa != null || this.idAssetEsperienza != null;
        }

        protected getColumns() {
            var columns = super.getColumns();

            // Add column
            columns.unshift({
                field: 'Delete Row',
                name: '',
                format: ctx => '<a class="inline-action delete-row" title="delete">' +
                    '<i class="fa fa-trash-o text-red"></i></a>',
                width: 24,
                minWidth: 24,
                maxWidth: 24
            });

            return columns;
        }

        protected getButtons(): Serenity.ToolButton[] {
            var buttons = super.getButtons();

            // Remove Button
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "column-picker-button"), 1);

            // Remove Button
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);

            // Remove Button
            //buttons.splice(Q.indexOf(buttons, x => x.cssClass == "refresh-button"), 1);

            //Add a Button
            buttons.push({
                title: 'Seleziona',
                hint: '',
                cssClass: 'goto-seleziona',
                icon: 'fa-list-ol',
                separator: true,
                onClick: () => { /*Add Function Here */
                    if (this.ambito == AmbitoEnum.VisualizzaAssetEsperienze) {
                        //
                        var assetEsperienzePickerDialog = new AssetEsperienzePickerDialog({
                            hideAssetEsperienze: this.view.getItems().map(x => x.IdRisorsa)
                        });
                        //
                        assetEsperienzePickerDialog.onSuccess = (selected) => {
                            // filter already existing products
                            selected = selected.filter(x => !Q.any(this.view.getItems(), y => y.IdAssetEsperienza == x.IdAssetEsperienza));

                            for (var sel of selected) {
                                var item = <AssetEsperienzeRisorseRow>{
                                    IdRisorsa: this.idRisorsa,
                                    IdAssetEsperienza: sel.IdAssetEsperienza
                                    //,FaseTitolo: sel.Titolo
                                };

                                AssetEsperienzeRisorseService.Create({
                                    Entity: item
                                },
                                    response => {
                                        this.view.addItem({
                                            IdAssetEsperienzaRisorsa: response.EntityId,
                                            IdRisorsa: this.idRisorsa,
                                            IdAssetEsperienza: sel.IdAssetEsperienza,
                                            IdAssetEsperienzaNome: sel.Nome
                                        });
                                        //
                                        this.refresh();
                                    },
                                    {
                                        async: false
                                    });
                            }

                            return true;
                        };
                        //
                        assetEsperienzePickerDialog.dialogOpen();
                    }
                    if (this.ambito == AmbitoEnum.VisualizzaRisorse) {

                        var risorsePickerDialog = new RisorsePickerDialog({
                            hideRisorse: this.view.getItems().map(x => x.IdAssetEsperienza)
                        });

                        risorsePickerDialog.onSuccess = (selected) => {
                            selected = selected.filter(x => !Q.any(this.view.getItems(), y => y.IdRisorsa == x.IdRisorsa));

                            for (var sel of selected) {
                                var item = <AssetEsperienzeRisorseRow>{
                                    IdAssetEsperienza: this.idAssetEsperienza,
                                    IdRisorsa: sel.IdRisorsa,
                                    //IdRisorsaNome: sel.Nome
                                };

                                AssetEsperienzeRisorseService.Create({
                                    Entity: item
                                },
                                    response => {
                                        this.view.addItem({
                                            IdAssetEsperienzaRisorsa: response.EntityId,
                                            IdAssetEsperienza: this.idAssetEsperienza,
                                            IdRisorsa: sel.IdRisorsa,
                                            IdRisorsaNome: sel.Nome
                                        });
                                        //
                                        this.refresh();
                                    },
                                    {
                                        async: false
                                    });
                            }

                            return true;
                        };

                        risorsePickerDialog.dialogOpen();
                    }
                }
            });

            //
            return buttons;
        }

        protected onClick(e: JQueryEventObject, row: number, cell: number): void {

            // let base grid handle clicks for its edit links
            super.onClick(e, row, cell);

            // if base grid already handled, we shouldn"t handle it again
            if (e.isDefaultPrevented())
                return;

            // get reference to current item
            var item = this.itemAt(row);

            // get reference to clicked element
            var target = $(e.target);

            // if user clicks "i" element, e.g. icon
            if (target.parent().hasClass('inline-action'))
                target = target.parent();

            if (target.hasClass('inline-action')) {
                e.preventDefault();

                if (target.hasClass('delete-row')) {
                    Q.confirm('Desideri eliminare il record selezionato?', () => {
                        AssetEsperienzeRisorseService.Delete({
                            EntityId: item.IdAssetEsperienzaRisorsa
                        },
                            response => {
                                this.view.deleteItem(item.IdAssetEsperienzaRisorsa);
                                this.refresh();
                            },
                            { async: false });
                    });
                }
            }
        }

        // +++++++++++++++++++++++++++++++++++++++++++
        private _ambito: AmbitoEnum = AmbitoEnum.Indefinito;
        private _idRisorsa: number;
        private _idAssetEsperienza: number;

        // +++++++++++++++++++++++++++++++++++++++++++
        get ambito() {
            return this._ambito;
        }

        set ambito(value: AmbitoEnum) {
            if (this._ambito != value) {
                this._ambito = value;

                if (this._ambito == AmbitoEnum.VisualizzaAssetEsperienze) {
                    var columns = this.slickGrid.getColumns();

                    var nIndice = Q.indexOf(columns, x => x.field == AssetEsperienzeRisorseRow.Fields.IdRisorsaNome);
                    columns.splice(nIndice, 1);

                    //nIndice = Q.indexOf(columns, x => x.field == AssetEsperienzeRisorseRow.Fields.UnitaNome);
                    //columns.splice(nIndice, 1);

                    this.slickGrid.setColumns(columns);
                }

                if (this._ambito == AmbitoEnum.VisualizzaRisorse) {
                    var columns = this.slickGrid.getColumns();

                    var nIndice = Q.indexOf(columns, x => x.field == AssetEsperienzeRisorseRow.Fields.IdAssetEsperienzaNome);
                    columns.splice(nIndice, 1);

                    this.slickGrid.setColumns(columns);
                }
            }
        }

        // +++++++++++++++++++++++++++++++++++++++++++
        get idAssetEsperienza() {
            return this._idAssetEsperienza;
        }

        set idAssetEsperienza(value: number) {
            if (this._idAssetEsperienza != value) {
                this._idAssetEsperienza = value;
                this.setEquality(AssetEsperienzeRisorseRow.Fields.IdAssetEsperienza, value);
                this.refresh();
            }
        }

        // +++++++++++++++++++++++++++++++++++++++++++
        get idRisorsa() {
            return this._idRisorsa;
        }

        set idRisorsa(value: number) {
            if (this._idRisorsa != value) {
                this._idRisorsa = value;
                this.setEquality(AssetEsperienzeRisorseRow.Fields.IdRisorsa, value);
                this.refresh();
            }
        }
    }
}